import Big from 'big.js'

import { makeCurrency } from '$lib/factories'
import type { Currency } from '$lib/types/client_types'

export function myBig(val: any) {
	console.log('myBig() val:', val)
	if (val) return Big(val)
	else {
		return Big(0)
	}
}

export function containsNonNumeric(theValue : string) : boolean
{
	// Only positive numbers
	// const regexNumbers = new RegExp(/[^0-9.]/g)

	const regexNumbers = new RegExp(/[^0-9.-]/g)
	const containsNonNumeric = theValue.match(regexNumbers)
	if (containsNonNumeric) return true
	return false
}

export async function downloadFile(url: string, fileName: string) {
	const file = await fetch(url)
	const fileBlob = await file.blob()
	const fileUrl = URL.createObjectURL(fileBlob)

	const downloadElement = document.createElement('a')
	downloadElement.href = fileUrl
	downloadElement.download = fileName

	document.body.appendChild(downloadElement)
	downloadElement.click()
	document.body.removeChild(downloadElement)
	URL.revokeObjectURL(fileUrl)
}

export const getDayDiff = (endDate: number, startDate: number): number => {
	//const dayDiff = Math.floor((Date.now() - Date.parse(get(account).registered_at)) / (1000*60*60*24));
	return Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24))
}

export const getCurrencyFromArray = (currencies: Currency[], c: string, def = 'usd') => {
	let ctry = currencies.find((co) => co.id === c)

	if (ctry) return ctry

	ctry = currencies.find((co) => co.id === def)

	if (ctry) return ctry

	//this should never happen
	return makeCurrency()
}

export const highlightText = (msg: string, repl: string): string => {
	msg = msg || '' // normalize msg

	if (!repl || repl === '')
		// normalize repl
		return msg

	const msgToUpper = msg.toUpperCase()
	const searchToUpper = repl.toUpperCase()
	const pos = msgToUpper.indexOf(searchToUpper)
	if (pos < 0) {
		return msg
	}

	const lenSearch = searchToUpper.length
	const highlightMsg =
		msg.substr(0, pos) + '<b>' + msg.substr(pos, lenSearch) + '</b>' + msg.substr(pos + lenSearch)

	return highlightMsg
}

export function testJSON(text: string) {
	if (typeof text !== 'string') {
		return false
	}
	try {
		JSON.parse(text)
		return true
	} catch (err) {
		return false
	}
}

function componentToHex(c: number) {
	const hex = c.toString(16)
	return hex.length == 1 ? '0' + hex : hex
}

// export function rgbToHex(r: number, g: number, b: number) {
// 	return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b)
// }

export type RGB = { r: number; g: number; b: number }
export type HEX = `#${string}`
export const blankRGB = { r: 255, g: 255, b: 255 }

export function rgbToHex(rgb: RGB) {
	return '#' + componentToHex(rgb.r) + componentToHex(rgb.g) + componentToHex(rgb.b)
}

export function hexToRgb(hex: HEX) {
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
	return result
		? {
			r: parseInt(result[1], 16),
			g: parseInt(result[2], 16),
			b: parseInt(result[3], 16)
		}
		: null
}

export function validUUID(value: string){
	const matchs = value.match('^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$')
	if (matchs === null) {
		return false
	}
	return true
}